//@ts-check
import { View } from '@adobe/react-spectrum';
import Document from '@spectrum-icons/workflow/Document';
import React from 'react';
import { GridList } from 'react-aria-components';

import { DetailsSectionView } from '@exchange-frontends/components';

import { DetailHeading } from '../../../../../components/DetailHeading';
import HelpSupportGridListItem from './HelpSupportGridListItem';

/**
 * @param {object} props
 * @param {import('@action-types/ecApp').SolutionMedia} props.solutionMedia
 * @param {string} [props.title='Documentation']
 */
const SlnSideBarDocuments = ({ solutionMedia, title = 'Documentation' }) => {
  const items = [
    { name: 'Solution architecture diagram', data: solutionMedia?.solutionArchitectureDiagram },
    { name: 'Solution case study', data: solutionMedia?.solutionCaseStudy },
    { name: 'Solution one-pager', data: solutionMedia?.solutionOnepager },
    { name: 'Solution client presentation', data: solutionMedia?.solutionClientPresentation },
  ]
    .filter((item) => item.data?.url)
    .sort((a, b) => a.data?.order - b?.data?.order);

  if (!items.length) {
    return null;
  }

  return (
    <View marginBottom="size-400">
      <DetailHeading level={4}>{title}</DetailHeading>
      <DetailsSectionView padding="size-0">
        <GridList aria-label="help and support" selectionMode="multiple">
          {items.map((item) => (
            <HelpSupportGridListItem
              key={item.data?.url}
              icon={<Document size="S" />}
              label={item.name}
              dataLaunchId={`${title}: ${item.name}`}
              onClick={() => window.open(item.data?.url, '_blank', 'noopener,noreferrer')}
            />
          ))}
        </GridList>
      </DetailsSectionView>
    </View>
  );
};

export default SlnSideBarDocuments;
